

export const SelectDestionations = () => {
  return (
    <>
        <option value=""></option>
        <option value="ATO">Aeropuerto Internacional "La Aurora"</option>
        <option value="Antigua">Antigua Guatemala</option>
        <option value="Pana">Panajachel</option>
        <option value="San Pedro">San Pedro la Laguna</option>
        <option value="El Paredon">El Paredon</option>
        <option value="Xela">Quetzaltenango</option>
        <option value="Chichi">Chichicastenango</option>
    </>
  )
}
